export default "__VITE_ASSET__DoirfXY8__"